<script setup lang="ts">
import { StyleValue, computed } from 'vue';
import { LayoutDetails, LayoutItem, Position } from './types';
import { calculateLayoutItemPosition } from './utils/calculateUtils';

const props = defineProps<{
  useCssTransforms: boolean;
  item: LayoutItem;
  details: LayoutDetails;
}>();

const pos = computed<Position>(() => calculateLayoutItemPosition(props.details, props.item));

const positionStyle = computed<StyleValue>(() => {
  const translate = `translate(${pos.value.left}px,${pos.value.top}px)`;

  return props.useCssTransforms
    ? {
        // css transforms use translate
        transform: translate,
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        width: `${pos.value.width}px`,
        height: `${pos.value.height}px`,
        position: 'absolute',
        left: '0',
        right: 'auto',
      }
    : {
        top: `${pos.value.top}px`,
        left: `${pos.value.left}px`,
        width: `${pos.value.width}px`,
        height: `${pos.value.height}px`,
        position: 'absolute',
      };
});

const computedStyle = computed<StyleValue>(() => {
  const style = positionStyle.value;
  return style;
});
</script>
<template>
  <div class="grid-item" :style="computedStyle" style="height: 100%">
    <div class="relative h-full w-full">
      <slot></slot>
    </div>
  </div>
</template>
